import { useStartupParamsStore } from "@/store/startupParams";

type GoalShareVariant = "active" | "completed";

interface ShareGoalParams {
  variant: GoalShareVariant;
  rewardAmount: number;
  ridesRequired: number;
}

const SHARE_CONFIG: Record<
  string,
  {
    botLink: string;
    park: string;
    rides: string;
  }
> = {
  delivery: {
    botLink: "https://t.me/BogatiyKurierBot?start=utm_personalGoalDelivery",
    park: "БК",
    rides: "заказов",
  },
  eats: {
    botLink: "https://t.me/BK_EdaBot?start=utm_personalGoalEda",
    park: "БК Еде",
    rides: "заказов",
  },
  taxi: {
    botLink: "https://t.me/BogatiyTaxistBot?start=utm_personalGoal",
    park: "БТ",
    rides: "поездок",
  },
};

const DEFAULT_SHARE_CONFIG = SHARE_CONFIG.delivery;

export const useShareGoal = () => {
  const serviceType = useStartupParamsStore((state) => state.serviceType);

  return ({ variant, rewardAmount, ridesRequired }: ShareGoalParams) => {
    const config = serviceType
      ? SHARE_CONFIG[serviceType] ?? DEFAULT_SHARE_CONFIG
      : DEFAULT_SHARE_CONFIG;
    const reward = `${rewardAmount}₽`;
    const text =
      variant === "completed"
        ? `Добил цель от ${config.park}💪 \n${reward} теперь у меня) \n\nПолучить цель тут👇\n${config.botLink}`
        : `Смотрите, какую цель в ${config.park} выбил \n${reward} за ${ridesRequired} ${config.rides}, это же прям изи \n\nПолучить цель тут👇\n${config.botLink}`;
    const encodedText = encodeURIComponent(text);

    window.open(`https://t.me/share/url?url=${encodedText}`, "_blank");
  };
};
